import React, { useContext, useState, useRef } from 'react';
import { Box, IconButton } from '@mui/material';
import { ThemeContext } from 'styled-components';
import { AuthContext } from '../../auth/providers/AuthProvider';
import { CoinVerticalIcon, LightningIcon } from '@phosphor-icons/react';
import QuickActionsMenu from './QuickActionsMenu';

const QuickActionsButton = () => {
    const theme = useContext(ThemeContext);
    const { authClaims } = useContext(AuthContext);
    const [menuOpen, setMenuOpen] = useState(false);
    const anchorRef = useRef(null);

    // Only show when logged in
    if (!authClaims) {
        return null;
    }

    const handleClick = () => {
        setMenuOpen(true);
    };

    const handleMenuClose = () => {
        setMenuOpen(false);
    };

    return (
        <Box
            sx={{
                position: 'fixed',
                bottom: '80px', // Position above footer (adjust based on footer height)
                right: '24px',
                zIndex: 1000,
            }}
        >
            <IconButton
                ref={anchorRef}
                onClick={handleClick}
                sx={{
                    width: '70px',
                    height: '70px',
                    backgroundColor: 'transparent',
                    color: theme.colors.buttonText || 'white',
                    position: 'relative',
                    padding: 0,
                }}
            >
                {/* Coin background - fills the container */}
                <CoinVerticalIcon
                    size={56}
                    // weight="fill"
                    style={{
                        position: 'absolute',
                        zIndex: 1,
                        color: theme.colors.quickActionIcon,
                        width: '100%',
                        height: '100%',
                    }}
                />
                {/* Lightning overlay - positioned further left */}
                <LightningIcon
                    size={30}
                    weight="fill"
                    style={{
                        position: 'absolute',
                        zIndex: 2,
                        color: theme.colors.quickActionIcon,
                        top: '50%',
                        left: '20%',
                        transform: 'translateY(-50%)',
                    }}
                />
            </IconButton>
            <QuickActionsMenu
                anchorEl={anchorRef.current}
                open={menuOpen}
                onClose={handleMenuClose}
            />
        </Box>
    );
};

export default QuickActionsButton;
